import { apiFetch } from "./client";

export type StatisticsUnitNightsRow = {
  einheit: string;
  n: number;
};

export type StatisticsGruppenartSlice = {
  name: string;
  value: number;
  color: string;
};

export type Statistics = {
  von: string;
  bis: string;
  incl_storno: boolean;
  n_bookings: number;
  n_guest_nights: number;
  avg_nights_per_booking: number;
  n_adults_sum: number;
  n_children_sum: number;
  revenue_sum: number;
  kurtaxe_sum: number;
  month_labels: string[];
  month_booking_counts: number[];
  unit_nights_rows: StatisticsUnitNightsRow[];
  gruppenart_bookings: StatisticsGruppenartSlice[];
  gruppenart_nights: StatisticsGruppenartSlice[];
  storno_in_range_excluded: number;
};

export type StatisticsParams = {
  von: string;
  bis: string;
  inclStorno: boolean;
};

export function fetchStatistics({ von, bis, inclStorno }: StatisticsParams) {
  const qs = new URLSearchParams({
    von,
    bis,
    incl_storno: inclStorno ? "1" : "0",
  });
  return apiFetch<Statistics>(`/api/statistics?${qs.toString()}`);
}
